import { Box, Typography } from "@mui/material";
import InfoIconOutlined from "@mui/icons-material/InfoOutlined";

type Props = {
  title: string;
};

export const Header = ({ title }: Props) => (
  <Box display="flex" alignItems="center" gap={2}>
    <InfoIconOutlined color="primary" />
    <Typography variant="h5" component="h1" fontWeight={600}>
      {title}
    </Typography>
  </Box>
);
